import { IconButton } from "@mui/material";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { useState } from "react";
import AddEditRecord from "../add-edit-record-account";
import AddEditPayment from "src/pages/settings/tabs/payment-list/add-edit-payment";
import AddEditContributorPopup from "src/pages/settings/tabs/capital/tabs/owners/add-edit-contributor";
import AddEditCategoryPopup from "src/pages/fixed-assets/tabs/categories/add-edit-category";
import AddEditAssetPopup from "src/pages/fixed-assets/tabs/accounts/add-edit-asset";

type Props = { row: any; refetch: Function };

const AddNewBtn = ({ row, refetch }: Props) => {
  const [open, setOpen] = useState(false);
  const [openPayment, setOpenPayment] = useState(false);
  const [openCapital, setOpenCapital] = useState(false);
  const [openCategory, setOpenCategory] = useState(false);
  const [openAsset, setOpenAsset] = useState(false);

  const handleCloseAdd = () => setOpen(false);
  const handleCloseAddPayment = () => setOpenPayment(false);
  const handleCloseAddCapital = () => setOpenCapital(false);
  const handleCloseAddCategory = () => setOpenCategory(false);
  const handleCloseAsset = () => setOpenAsset(false);

  const handleAdd = () => {
    console.log({ row });
    if (
      row.node_type === "subcategory" &&
      row.system_key === "cash_and_cash_equivalent"
    ) {
      setOpenPayment(true);
    } else if (
      row.node_type === "subcategory" &&
      row.system_key === "owner_current_account"
    ) {
      setOpenCapital(true);
    } else if (row.system_key === "fixed_assets") {
      setOpenCategory(true);
    } else if (row.source_type === "operation_cost_category_assets") {
      setOpenAsset(true);
    } else {
      setOpen(true);
    }
  };

  return (
    <>
      <IconButton size="small" onClick={handleAdd}>
        <AddOutlinedIcon fontSize="small" />
      </IconButton>
      {open && (
        <AddEditRecord
          open={open}
          handleClose={handleCloseAdd}
          refetch={refetch}
          parent={row}
        />
      )}
      {openPayment && (
        <AddEditPayment
          open={openPayment}
          handleClose={handleCloseAddPayment}
          refetch={refetch}
          isCashOnly={true}
        />
      )}
      {openCapital && (
        <AddEditContributorPopup
          open={openCapital}
          handleClose={handleCloseAddCapital}
          refetch={refetch}
        />
      )}
      {openCategory && (
        <AddEditCategoryPopup
          open={openCategory}
          handleClose={handleCloseAddCategory}
          refetch={refetch}
        />
      )}
      {openAsset && (
        <AddEditAssetPopup
          open={openAsset}
          handleClose={handleCloseAsset}
          refetch={refetch}
          categoryId={row.source_id}
        />
      )}
    </>
  );
};

export default AddNewBtn;
